import React from "react";
import ReactDOM from "react-dom";
import BaseLinkModel from "../../models/BaseLinkModel";
import BaseNodeModel from "../../models/BaseNodeModel";
import Utility from "../../utilities/Utility";
import CanvasTabManager from "../../utilities/CanvasTabManager";
import { Constant } from '../../const';
import AppValidation from "../../utilities/AppValidation";
import LoadingSpinner from '../components/LoadingSpinner';
import Graph from "../../Graph";
import WorkerManager from '../../utilities/workers/WorkerManager';
import { CanvasClient } from "@app/page-components/app/canvas";
import { updateTree } from "@app/utilities";


export default class ValidatorDialog extends React.Component {
    /**
     * Dialog for application validation
     * @module ValidatorDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            unusedModules: [],
            unusedIntents: [],
            unusedObjects: [],
            unusedVariables: [],
            contentIsLoading: true

        };
        this.workers = new WorkerManager();
        this.gettheerrors = this.gettheerrors.bind(this);
        this.getListItem = this.getListItem.bind(this);
        this.deleteAllUnused = this.deleteAllUnused.bind(this);
        this.deleteUnused = this.deleteUnused.bind(this);
        this.deleteUnusedObject = this.deleteUnusedObject.bind(this);
        this.deleteAllUnusedObjectsByType = this.deleteAllUnusedObjectsByType.bind(this);
        this.getUnusedStateArray = this.getUnusedStateArray.bind(this);
    }

    /**
     * Open and jump to module tab
     * @param {Object} module Serialized module node model
     */
    openCanvas(module, diagramValidate = true) {
        this.props.closeDialog();
        $('a[href="#"]')[0].click();
        CanvasTabManager.addTab(module);

        var clientInstance = ReactDOM.render(
            <CanvasClient node={module} clientId={module.id + '_canvas'} />,
            document.getElementById(module.id + '_canvas')
        );
        window.apm.cache.put(Constant.k.NAMESPACE_CLIENT, module.id + '_canvas', clientInstance);
        window.apm.cache.get(Constant.k.NAMESPACE_CLIENT, module.id + '_canvas').updateFocus();
        if (diagramValidate) window.apm.postEventToCurrentView({ target: "request-validate", appValidation: true });
        window.location.hash = "";

    }
    openAllModules(modules) {
        modules.forEach(module => {
            this.openCanvas(module.modules, false);
        })

    }
    deleteSingleComponent(component) {
        for (var c = 0; c < this.state.errors[component.errorType].length; c++) {
            if (this.state.errors[component.errorType][c][component.errorType].id === component.id) {
                this.state.errors[component.errorType].splice(c, 1);
            }
        }
        var componentIndex = window.apm.serialized.components[component.type].findIndex(mo => mo.id === component.id);
        const treeDom = $("#tl_container");
        var treeObj = treeDom.jstree();
        window.apm.serialized.components[component.type].splice(componentIndex, 1);
        treeObj.settings.core.data = window.apm.getTree();
        treeObj.refresh();
        window.apm.setSerializedChanged();
        this.setState({ errors: this.state.errors })
    }
    deletemultipleComponents(type) {
        if (type !== "unUsedModules" && type !== "variables" && type !== "intents") {
            this.state.errors[type].forEach(no => {
                var noIndex = window.apm.serialized.components["objects"].findIndex(mo => mo.id === no[type].id);
                if (noIndex !== -1) { window.apm.serialized.components["objects"].splice(noIndex, 1); }
            })
        }
        else if (type === "unUsedModules") {
            this.state.errors[type].forEach(no => {
                var noIndex = window.apm.serialized.components["modules"].findIndex(mo => mo.id === no["unUsedModules"].id);
                if (noIndex !== -1) { window.apm.serialized.components["modules"].splice(noIndex, 1); }
            });
        }
        else {
            this.state.errors[type].forEach(no => {
                var noIndex = window.apm.serialized.components[type].findIndex(mo => mo.id === no[type].id);
                if (noIndex !== -1) { window.apm.serialized.components[type].splice(noIndex, 1); }
            });
        }
        this.state.errors[type] = [];
        updateTree();
        window.apm.setSerializedChanged();
        this.setState({ errors: this.state.errors })
    }
    /**
     * Select variable in tree
     * @param {Object} variable Serialized variable model
     */
    selectVariable(variable) {
        this.props.closeDialog();
        $('a[href="#"]')[0].click();
        const tree = $("#tl_container").jstree();
        if (tree) {
            tree.deselect_all();
            tree.select_node(variable.id);
            window.apm.postEventToCurrentView({ target: "request-clear-selection" });
            window.apm.postEventToCurrentView({ target: "request-component-panel", event: variable });
        }
    }

    /**
     * Handle click on error list
     * @param {Object} element Diagram node model in the case of clicking the node directly, or tree model if clicking on variable
     */
    onClickElement(element) {
        this.props.closeDialog();
        if (element instanceof BaseLinkModel) {
            window.apm.postEventToCurrentView({
                target: "request-select-matching",
                event: { id: element.id, type: "link" }
            });
        }
        if (element instanceof BaseNodeModel) {
            window.apm.postEventToCurrentView({
                target: "request-select-matching",
                event: { id: element.id, type: element.type }
            });
        }
        if (element.type === "variable") {
            const tree = $("#tm_container").jstree();
            if (tree) {
                tree.deselect_all();
                tree.select_node(element.id);
                window.apm.postEventToCurrentView({ target: "request-select-matching", event: element });
            }
        }
    }

    /**
     * Render error list
     * @param {Array} errors
     * @returns {Array}
     */
    renderErrors(errors) {
        const elements = [];
        const err = [];
        if (errors.results.beginNode.length > 0) {
            err.push([errors.results.beginNode, window.l.popup.begin_node]);
        }
        if (errors.results.inputNode.length > 0) {
            err.push([errors.results.inputNode, window.l.popup.input_node]);
        }
        if (errors.results.exitNode.length > 0) {
            err.push([errors.results.exitNode, window.l.popup.exit_node]);
        }
        if (errors.results.dataNode.length > 0) {
            err.push([errors.results.dataNode, window.l.popup.data_node]);
        }
        if (errors.results.links.length > 0) {
            err.push([errors.results.links, window.l.popup.transition]);
        }
        if (errors.results.promptReferenceNode.length > 0) {
            err.push([errors.results.promptReferenceNode, window.l.popup.prompt_reference]);
        }
        if (errors.results.moduleReferenceNode.length > 0) {
            err.push([errors.results.moduleReferenceNode, window.l.popup.prompt_reference]);
        }
        if (errors.results.reportNode.length > 0) {
            err.push([errors.results.reportNode, window.l.popup.reportNode]);
        }
        if (errors.results.savePrompt.length > 0) {
            err.push([errors.results.savePrompt, window.l.popup.Save_Prompt]);
        }
        if (errors.results.promptNode.length > 0) {
            err.push([errors.results.promptNode, window.l.popup.Prompt]);
        }
        if (errors.results.nodes.length > 0) {
            err.push([errors.results.nodes, window.l.popup.node]);
        }
        if (errors.results.unusedLinks.length > 0) {
            err.push([errors.results.unusedLinks, window.l.popup.unreachable_link])
        }
        if (errors.results.unusedNodes.length > 0) {
            err.push([errors.results.unusedNodes, window.l.popup.unreachable_node])
        }
        if (errors.results.unusedLocalVariables.length > 0) {
            err.push([errors.results.unusedLocalVariables, window.l.popup.unused_local_variable])
        }
        if (errors.results.illegalObjects.length > 0) {
            err.push([errors.results.illegalObjects, window.l.popup.illegalObjects])
        }
           
        for (var e = 0; e < err.length; e++) {
            const errorElements = [];
            var id = Utility.uuid4();
            for (var i = 0; i < err[e][0].length; i++) {
                const elem = err[e][0][i].elem;
                errorElements.push(
                    <div key={id + i}>
                        {(() => {
                            if (elem) {
                                var elemName = elem.name ? elem.name + " : " : "";
                                return <a onClick={() => this.onClickElement(elem)}>{elemName}{err[e][0][i].error}</a>;
                            } else {
                                return <span>{err[e][0][i].error}</span>;
                            }
                        })()}
                    </div>
                );
            }

            elements.push(
                <div className={"card"} key={id}>
                    <div>
                        <h5>
                            <a className={"error-title"} data-toggle={"collapse in"} href={"#" + id}
                                aria-controls={id} aria-expanded={"false"}>
                                {err[e][0].length} {err[e][1]} {err[e][0].length > 1 ? window.l.popup.errors : window.l.popup.error}
                            </a>
                        </h5>
                    </div>

                    <div id={id} className={"collapse in"} aria-expanded={"false"}>
                        <div>
                            {errorElements}
                        </div>
                    </div>
                </div>
            );
        }
        return elements;

    }

    componentDidMount() {        
        const initValidation = window.setTimeout(() => {this.gettheerrors()}, 500);
    }

    gettheerrors() {

        if (this.props.singleerrors) {

            this.setState({ errors: { results: this.getFlowModel().validateDiagram(true) }, contentIsLoading: false });

        } else {
            const appValidationResults = AppValidation.applicationValidation(window.apm.serialized);
            
            this.workers.postMessage("initApplicationUsedIn", (data) => {                    
                this.setState({ unusedModules: data.unusedModules });
                this.setState({ unusedIntents: data.unusedIntents});
                this.setState({ unusedObjects: data.unusedObjects});
                this.setState({ unusedVariables: data.unusedVariables});
                this.setState({ duplicateObjectNames: data.duplicateObjectNames});
                this.setState({ duplicateModuleNames: data.duplicateModuleNames});
                this.setState({ errors: appValidationResults, contentIsLoading: false });
            }, window.apm.serialized);
        }
    }

    getDataModel() {
        if (this.props.node.elemId) {
            return window.apm.getNode(this.props.node.elemId);
        } else {
            return window.apm.getNode(this.props.node.id);
        }
    }

    getGraphModel() {
        if (!this.graphModel) {
            this.graphModel = new Graph(this.getDataModel());
            this.graphModel.getEngine().clientId = this.props.clientId;
            this.graphModel.getEngine().setCanvas(this.canvasNodeRef);
        }
        return this.graphModel;
    }

    getFlowModel() {
        return this.getGraphModel().getEngine().getDiagramModel();
    }


    getListItem(item, status, clickHandler) {
        if (item.type === "module" && !item.props.iconClass) {
            item.props.iconClass = "package";
        }
        return (
            <tr key={item.id}>
                <td style={{ width: "70%" }}>
                    <i style={{ paddingRight: "2px" }} className={"fe icon-" + item.props.iconClass} />{item.name}
                </td>
                <td style={{ width: "30%" }}>
                    {(clickHandler) ?
                        <a className={"error-title"} onClick={clickHandler}>{status}</a> :
                        <span className={"error-title"} onClick={clickHandler}>{status}</span>}
                </td>
            </tr>
        );
    }

    getUnusedObjectsList(){
        const {unusedObjects} = this.state;
        const objTypes = Array.from(new Set(unusedObjects.map(unused => unused.props.nodeTypeName))).sort();
        const list = [];
        
        objTypes.map(type => {
            list.push(<table className={"table table-condensed"} style={{margin: '0 0 4px'}}><tbody><tr key={type + 'header'}><td style={{ width: "70%" }}><b>{type}</b></td><td style={{textAlign: 'right', display: 'none'}}><a data-type={type} onClick={this.deleteAllUnusedObjectsByType}>delete all</a></td></tr></tbody></table>);
            unusedObjects.filter(obj => obj.props.nodeTypeName === type).sort((a,b) => (a.name < b.name)? -1: (a.name > b.name)? 1: 0).map(obj => {
                list.push(<table className={"table table-condensed"} style={{margin: '0'}}><tbody><tr key={type + 'row'}>
                    <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + obj.props.iconClass} />{obj.name}</td>
                    <td style={{textAlign: 'right', display: 'none'}}><a data-objid={obj.id} onClick={this.deleteUnusedObject}>delete</a></td></tr></tbody></table>); 
            })
        });

        return list;
    }

    getUnusedStateArray(node){
        if(node.type === 'module'){
            return this.state.unusedModules;    
        }
        if(node.type === 'object'){
            return this.state.unusedObjects;    
        }
        if(node.type === 'intents'){
            return this.state.unusedIntents;    
        }
        if(node.type === 'variable'){
            return this.state.unusedVariables;    
        }
    }

    deleteAllUnused(unused){
        // remove from serialized
        unused.forEach(u => {
            window.apm.removeNode(u.id)
        });

        // repaint Validator Unused UI
        if(unused[0].type === 'module'){
            this.setState({unusedModules: []});
        }
        if(unused[0].type === 'object'){
            this.setState({unusedObjects: this.state.unusedObjects.filter(u => u.props.nodeTypeName !== unused[0].props.nodeTypeName)});
        }
        if(unused[0].type === 'intent'){
            this.setState({unusedIntents: []});
        }
        if(unused[0].type === 'variable'){
            this.setState({unusedVariables: []});
        }

    }
    
    deleteUnused(node){
        // remove from serialized 
        window.apm.removeNode(node.id);

        if(node.type === 'module'){
            this.setState({unusedModules: this.state.unusedModules.filter(mod => mod.id !== node.id)})
        }
        if(node.type === 'object'){
            this.setState({unusedObjects: this.state.unusedObjects.filter(obj => obj.id !== node.id)})
        }
        if(node.type === 'intent'){
            this.setState({unusedIntents: this.state.unusedIntents.filter(int => int.id !== node.id)})
        }
        if(node.type === 'variable'){
            this.setState({unusedVariables: this.state.unusedVariables.filter(variable => variable.id !== node.id)})
        }
        
    }

    deleteUnusedObject(e){
        const objid = e.target.dataset.objid;
        this.deleteUnused(this.state.unusedObjects.find(o => o.id === objid));
    }

    deleteAllUnusedObjectsByType(e){
        const objs = this.state.unusedObjects.filter(obj => obj.props.nodeTypeName === e.target.dataset.type);
        this.deleteAllUnused(objs);
    }


    /**
     * React render
     * @returns {XML}
     */
    render() {
        if (this.state.errors.hasOwnProperty("modules") && this.state.errors.hasOwnProperty("variables") 
         || this.state.unusedModules && this.state.unusedModules.length > 0
         || this.state.unusedIntents && this.state.unusedIntents.length > 0
         || this.state.unusedObjects && this.state.unusedObjects.length > 0
         || this.state.unusedVariables && this.state.unusedVariables.length > 0
         || this.state.duplicateModuleNames
         || this.state.duplicateObjectNames) {
         
        return(
                <div>
                    <div className={"container-fluid element-dialog"}>
                        {this.state.duplicateModuleNames && Object.keys(this.state.duplicateModuleNames).length > 0 &&
                            <table className={"table table-condensed"}>
                            <thead>
                            <tr>
                                <td><b> Duplicate Module Names </b></td>
                                <td style={{textAlign: 'right'}}></td>
                                
                            </tr>
                            </thead>
                            
                                <tbody>
                                    {Object.entries(this.state.duplicateModuleNames).map(keyedArray => {
                                        return (<tr key={keyedArray[0]}>
                                            <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + keyedArray[1][0].props.iconClass} />{keyedArray[0]}</td>
                                            <td style={{textAlign: 'right'}}><a onClick={() => {}}>{keyedArray[1].length}</a></td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                            
                        }

                        {this.state.duplicateObjectNames && Object.keys(this.state.duplicateObjectNames).length > 0 &&
                            <table className={"table table-condensed"}>
                            <thead>
                            <tr>
                                <td><b> Duplicate Object Names </b></td>
                                <td style={{textAlign: 'right'}}></td>
                                
                            </tr>
                            </thead>
                            
                                <tbody>
                                    {Object.keys(this.state.duplicateObjectNames).map(key => {
                                       return this.state.duplicateObjectNames[key].map(arr => {
                                            return (<tr key={key}>
                                                <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + arr[0].props.iconClass} />{arr[0].name}</td>
                                                <td style={{textAlign: 'right'}}><a onClick={() => {}}>{arr.length}</a></td>
                                            </tr>)
                                        
                                       })
                                        
                                    })}
                                </tbody>
                            </table>
                            
                        }

                        {(Object.keys(this.state.errors).length === 0) && (
                            <p>{window.l.popup.no_error_found}</p>
                        )}
                        {this.state.errors.globalIntents && this.state.errors.globalIntents.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p><b>{"Global Intents"}</b></p>
                                <table className={"table table-condensed"}>
                                    <tbody>
                                        {this.state.errors.globalIntents.map(gi => {
                                            const message = (gi.globalIntents.type === "module") ? "No intent mapped" : "No module mapped";
                                            return this.getListItem(gi.globalIntents, message, null)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.compoundIntents && this.state.errors.compoundIntents.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p><b>{"Compound Intents"}</b></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.compoundIntents.map(ci => {

                                            return (<div id={Utility.uuid4()}>
                                                <table style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '33%' }}>From Intent 1</th>
                                                            <th style={{ width: '33%' }}>From Intent 2</th>
                                                            <th style={{ width: '33%' }}>To Intent</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr >
                                                            <td>{ci.compoundIntents.fromIntent1 ? ci.compoundIntents.fromIntent1.name : "???"}</td>
                                                            <td>{ci.compoundIntents.fromIntent2 ? ci.compoundIntents.fromIntent2.name : "???"}</td>
                                                            <td>{ci.compoundIntents.toIntent ? ci.compoundIntents.toIntent.name : "???"}</td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        
                        {this.state.errors.modules && this.state.errors.modules.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p>
                                    <b> {window.l.popup.module_errors} </b>
                                    <a onClick={() => this.openAllModules(this.state.errors.modules)} style={{ float: "right" }}>{window.l.popup.open_all}</a>
                                </p>
                                <table className={"table table-condensed"}>
                                    <tbody>
                                        {this.state.errors.modules.map(mod => {
                                            const errorCount = mod.results.errorCount;
                                            if (mod.results.hasOwnProperty('directMessage')) {
                                                return (
                                                    <tr key={mod.modules.id}>
                                                        <td style={{ width: "70%" }}> <i style={{ paddingRight: "2px" }} className={"fe icon-" + mod.modules.props.iconClass} />{mod.modules.name}</td>
                                                        <td style={{ width: "30%" }}>
                                                            {mod.results.directMessage}
                                                        </td>
                                                    </tr>)
                                            } else {
                                                return (<tr key={mod.modules.id}>
                                                    <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + mod.modules.props.iconClass} />{mod.modules.name}</td>
                                                    <td style={{ width: "30%" }}>
                                                        <a className={"error-title"} onClick={() => this.openCanvas(mod.modules)}>{errorCount + (errorCount > 1 ? window.l.popup.space_errors : window.l.popup.space_error)}</a>
                                                    </td>
                                                </tr>)
                                            }

                                        })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.intents && this.state.errors.intents.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p><b>{window.l.popup.unused_intents}</b></p>
                                <table className={"table table-condensed"}>
                                    <tbody>
                                        {this.state.errors.intents.map(i => {
                                            const callback = () => this.selectVariable(i.intents);
                                            return this.getListItem(i.intents, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.variables && this.state.errors.variables.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p><b>{window.l.popup.unused_variables}</b><a onClick={() => this.deletemultipleComponents("variables")} style={{ float: "right", display: 'none' }}>Delete All</a></p>
                                <table className={"table table-condensed"}>
                                    <tbody>
                                        {this.state.errors.variables.map(v => {
                                            const callback = () => this.selectVariable(v.variables);
                                            return this.getListItem(v.variables, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.promptReferenceNodes && this.state.errors.promptReferenceNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Prompt References"} </b><a onClick={() => this.deletemultipleComponents("promptReferenceNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.promptReferenceNodes.map(p => {
                                            const callback = () => this.selectVariable(p.promptReferenceNodes);
                                            return this.getListItem(p.promptReferenceNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.moduleReferenceNodes && this.state.errors.moduleReferenceNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Module References"} </b><a onClick={() => this.deletemultipleComponents("moduleReferenceNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.moduleReferenceNodes.map(mr => {
                                            const callback = () => this.selectVariable(mr.moduleReferenceNodes);
                                            return this.getListItem(mr.moduleReferenceNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.customNodes && this.state.errors.customNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Customs"} </b><a onClick={() => this.deletemultipleComponents("customNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.customNodes.map(cn => {
                                            const callback = () => this.selectVariable(cn.customNodes);
                                            return this.getListItem(cn.customNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.dataAccessCompletionNodes && this.state.errors.dataAccessCompletionNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Data Access Completion Nodes"} </b><a onClick={() => this.deletemultipleComponents("dataAccessCompletionNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.dataAccessCompletionNodes.map(dac => {
                                            const callback = () => this.selectVariable(dac.dataAccessCompletionNodes);
                                            return this.getListItem(dac.dataAccessCompletionNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.dataNodes && this.state.errors.dataNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Data Access Nodes"} </b><a onClick={() => this.deletemultipleComponents("dataNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.dataNodes.map(da => {
                                            const callback = () => this.selectVariable(da.dataNodes);
                                            return this.getListItem(da.dataNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.tabularRouterNodes && this.state.errors.tabularRouterNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Tabular Router"} </b><a onClick={() => this.deletemultipleComponents("tabularRouterNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.tabularRouterNodes.map(tr => {
                                            const callback = () => this.selectVariable(tr.tabularRouterNodes);
                                            return this.getListItem(tr.tabularRouterNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.dtmfNodes && this.state.errors.dtmfNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused DTMF Menu"} </b><a onClick={() => this.deletemultipleComponents("dtmfNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.dtmfNodes.map(dtmf => {
                                            const callback = () => this.selectVariable(dtmf.dtmfNodes);
                                            return this.getListItem(dtmf.dtmfNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.reportingNodes && this.state.errors.reportingNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Report Tags"} </b><a onClick={() => this.deletemultipleComponents("reportingNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.reportingNodes.map(rn => {
                                            const callback = () => this.selectVariable(rn.reportingNodes);
                                            return this.getListItem(rn.reportingNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.moduleExits && this.state.errors.moduleExits.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Module Exits"} </b><a onClick={() => this.deletemultipleComponents("moduleExits")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.moduleExits.map(err => {
                                            const callback = () => this.selectVariable(err.moduleExits);
                                            return this.getListItem(err.moduleExits, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.inputNodes && this.state.errors.inputNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Inputs"} </b><a onClick={() => this.deletemultipleComponents("inputNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.inputNodes.map(input => {
                                            const callback = () => this.selectVariable(input.inputNodes);
                                            return this.getListItem(input.inputNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.savedPromptNodes && this.state.errors.savedPromptNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Save Prompts"} </b><a onClick={() => this.deletemultipleComponents("savedPromptNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.savedPromptNodes.map(sp => {
                                            const callback = () => this.selectVariable(sp.savedPromptNodes);
                                            return this.getListItem(sp.savedPromptNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.playSavedPromptNodes && this.state.errors.playSavedPromptNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Play Saved Prompts"} </b><a onClick={() => this.deletemultipleComponents("playSavedPromptNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.playSavedPromptNodes.map(psp => {
                                            const callback = () => this.selectVariable(psp.playSavedPromptNodes);
                                            return this.getListItem(psp.playSavedPromptNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {this.state.errors.promptNodes && this.state.errors.promptNodes.length > 0 && (
                            <div style={{padding: '5px'}}>
                                <p> <b> {"Unused Prompts"} </b><a onClick={() => this.deletemultipleComponents("promptNodes")} style={{ float: "right", display: 'none'}}>Delete All</a></p>
                                <table className={"table table-condensed"} >
                                    <tbody>
                                        {this.state.errors.promptNodes.map(pn => {
                                            const callback = () => this.selectVariable(pn.promptNodes);
                                            return this.getListItem(pn.promptNodes, window.l.popup.unused, callback)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* unused modules */}
                        {this.state.unusedModules && this.state.unusedModules.length > 0 &&
                            <table className={"table table-condensed"}>
                            <thead>
                            <tr>
                                <td><b> Unused Modules </b></td>
                                <td style={{textAlign: 'right', display: 'none'}}><a onClick={() => this.deleteAllUnused(this.state.unusedModules)}>delete all</a></td>
                                
                            </tr>
                            </thead>
                            
                                <tbody>
                                    {this.state.unusedModules.sort((a,b) => (a.name < b.name) ? -1 : (a.name > b.name) ? 1: 0).map(mod => {
                                        return (<tr key={mod.id}>
                                            <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + mod.props.iconClass} />{mod.name}</td>
                                            <td style={{textAlign: 'right', display: 'none'}}><a onClick={() => this.deleteUnused(mod)}>delete</a></td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        }

                        {/* unused intents */}
                        {this.state.unusedIntents && this.state.unusedIntents.length > 0 &&
                            <table className={"table table-condensed"}>
                                <thead>
                                <tr>
                                    <td><b> Unused Intents </b></td>
                                    <td style={{textAlign: 'right', display: 'none'}}><a onClick={() => this.deleteAllUnused(this.state.unusedIntents)}>delete all</a></td>
                                    
                                </tr>
                                </thead>
                                <tbody>
                                    {this.state.unusedIntents.sort((a,b) => (a.name < b.name)? -1: (a.name > b.name)? 1: 0).map(intent => {
                                        return (<tr key={intent.id}>
                                            <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + intent.props.iconClass} />{intent.name}</td>
                                            <td style={{textAlign: 'right', display: 'none'}}><a onClick={() => this.deleteUnused(intent)}>delete</a></td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        }

                        {/* unused objects */}
                        {this.state.unusedObjects && this.state.unusedObjects.length > 0 &&
                            <div style={{marginBottom: '20px'}}>
                                <p>
                                    <b> Unused Objects </b>
                                </p>
                                {this.getUnusedObjectsList()}
                        </div>
                        }

                        {/* unused variables */}
                        {this.state.unusedVariables && this.state.unusedVariables.length > 0 &&
                            <table className={"table table-condensed"}>
                                <thead>
                                <tr>
                                    <td><b> Unused Variables </b></td>
                                    <td style={{textAlign: 'right', display: 'none'}}><a onClick={() => this.deleteAllUnused(this.state.unusedVariables)}>delete all</a></td>
                                    
                                </tr>
                                </thead>
                                <tbody>
                                    {this.state.unusedVariables.sort((a,b) => (a.name < b.name)? -1: (a.name > b.name)? 1: 0).map(variable => {
                                        return (<tr key={variable.id}>
                                            <td style={{ width: "70%" }}><i style={{ paddingRight: "2px" }} className={"fe icon-" + variable.props.iconClass} />{variable.name}</td>
                                            <td style={{textAlign: 'right', display: 'none'}}><a onClick={() => this.deleteUnused(variable)}>delete</a></td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        }

                    </div>
                </div>
                )
            }
            else {
                return (
                    <div>
                        <div className={"container-fluid element-dialog"}>
                            {this.state.contentIsLoading &&
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '295px'}}>
                                    <LoadingSpinner message={"Preparing Validation Results..."} />
                                    <div style={{position: 'absolute', 
                                        top: '180px',
                                        width: '706px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        height: '90px',
                                        justifyContent: 'space-between'}}>
                                        <div>Modules: {window.apm.serialized.components.modules.length}</div>
                                        <div>Objects: {window.apm.serialized.components.objects.length}</div>
                                        <div>Intents: {window.apm.serialized.components.intents.length}</div>
                                        <div>Variables: {window.apm.serialized.components.variables.length}</div>
                                    </div>
                                    
                                </div>
                            }
                            {!this.state.contentIsLoading && (this.state.errors.results.errorCount === 0) && (
                                <p>{window.l.popup.no_error_found}</p>
                            )}
                            {!this.state.contentIsLoading && (this.state.errors.results.errorCount > 0) && (
                                this.renderErrors(this.state.errors)
                            )}
                        </div>
                    </div >
                );
    
            }
    
    }
        
}
